/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMyAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNTAwNCAwSDIuNTAwMzlDMS42MjAzOSAwIDAuOTAwMzkxIDAuOCAwLjkwMDM5MSAxLjc3Nzc4VjE2TDYuNTAwMzkgMTMuMzMzM0wxMi4xMDA0IDE2VjEuNzc3NzhDMTIuMTAwNCAwLjggMTEuMzgwNCAwIDEwLjUwMDQgMFoiLz48L3N2Zz4=";